<template>
  <div style="overflow:hidden">
      <h2 style="margin-top: 50px">Area de Usuario</h2>

      <button @click="app.auth.tryLogin()">Login</button>
      <button @click="app.auth.logout()">Logout</button>

      <p>email: {{ app.auth.email }} </p>
      <p>userIdentifier: {{ app.auth.userIdentifier }} </p>
      <p>accessToken: {{ app.auth.accessToken }} </p>

  </div>

</template>

<script>
// import * as Msal from 'msal'
import { app } from '../../application.js'

export default {
  name: 'userComponent',
  data () {
    return {
        app: app,
    }
  },

  created(){
        
  },

  methods:{   

  },
  components: {
    
    },
  beforeMount(){
      
  }
}
</script>

<style lang="scss">

</style>
